import React, { useState, useEffect, useCallback } from "react";
import { Select, Input, Table, Button, Modal, Form, Col, Row, Spin, Checkbox, DatePicker } from "antd";
import { MdRefresh } from "react-icons/md";
import {
	useGetOrderMutation,
	useGenerateOrderMutation,
	useGetCategoriesMutation,
	useGetProductsByCategoryIdMutation,
	useGetProductTotalPriceMutation,
	useGetProductDetailsMutation
} from "../../redux/slices/productSlice";
import {
	useGetPatientsWithAppointmentsMutation,
	useGetPatientappointmentMutation,
	useGetFilteredpatientMutation
} from "../../redux/slices/patientSlice";
import {
	useGetSettingDetailsMutation
} from "../../redux/slices/userSlice";
import Swal from "sweetalert2";
import Shipping from "./shipping"
import ShippingDetails from "./ShippindDataModal";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { EyeOutlined, EditOutlined } from "@ant-design/icons";

const FILTER_STORAGE_KEY = "medspa_order_filter_preferences";
const SESSION_KEY = "medspa_session_id";

/**
 * Saves the current filter preferences to localStorage
 * @param {Object} preferences - The filter preferences to save
 */
const saveFilterPreferences = (preferences) => {
	try {
		localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(preferences));
	} catch (error) {
		console.error("Error saving filter preferences:", error);
	}
};

const generateSessionId = () => {
	return `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};

/**
 * Loads saved filter preferences from localStorage
 * @returns {Object|null} The saved preferences or null if none exist
 */

const { Option } = Select;
const { RangePicker } = DatePicker;

const isNewSession = () => {
	const currentSessionId = sessionStorage.getItem(SESSION_KEY);
	if (!currentSessionId) {
		// New session detected
		sessionStorage.setItem(SESSION_KEY, generateSessionId());
		return true;
	}
	return false;
};

const loadFilterPreferences = () => {
	try {
		// Check if this is a new session (page refresh)
		if (isNewSession()) {
			// Clear all saved preferences on actual page refresh
			localStorage.removeItem(FILTER_STORAGE_KEY);
			return null;
		}

		const savedPreferences = localStorage.getItem(FILTER_STORAGE_KEY);
		return savedPreferences ? JSON.parse(savedPreferences) : null;
	} catch (error) {
		console.error("Error loading filter preferences:", error);
		return null;
	}
};

const OrderingForMedication = () => {
	const savedPreferences = loadFilterPreferences();

	// Flag to track if initial data has been loaded after preferences are restored
	const [initialDataLoaded, setInitialDataLoaded] = useState(false);

	const { TextArea } = Input;
	const [form] = Form.useForm();
	const navigate = useNavigate();
	const userData = useSelector(
		(state) => state?.persistedReducer?.user
	);
	const [showFilterSection, setShowFilterSection] = useState(false);
	const [getPatientsWithAppointments, { isLoading: isLoadingPatient }] =
		useGetPatientsWithAppointmentsMutation();
	const [getPatientAppointments, { isLoading: isLoadingPatientAppointments }] = useGetPatientappointmentMutation();
	const [generateOrder] = useGenerateOrderMutation();
	const [getOrder, { isLoading: isLoadinggetOrder }] = useGetOrderMutation();
	const [getCategories, { isLoading: isCategoriesLoading }] = useGetCategoriesMutation();
	const [getProductsByCategoryId, { isLoading: isProductLoading }] = useGetProductsByCategoryIdMutation();
	const [getFilteredpatient, { isLoading: isFilterPatientLoading }] = useGetFilteredpatientMutation();
	const [getProductTotalPrice, { isLoading: isTotalPriceLoading }] = useGetProductTotalPriceMutation();
	const [getProductDetails, { isLoading: isProductDetailsLoading }] = useGetProductDetailsMutation();
	const [getSettingDetails,] = useGetSettingDetailsMutation();
	const [orderData, setorderData] = useState([]);
	const [orderTotal, setOrderTotal] = useState(0);
	const [selectedOrderData, setSelectedOrderData] = useState();
	const [last_visit_days, setLastVisit] = useState(null);
	const [selectedCategoryId, setSelectedCategoryId] = useState(savedPreferences?.selectedCategoryId || null);
	const [selectedProductId, setSelectedProductId] = useState(savedPreferences?.selectedProductId || null);
	const [patientTotal, setPatientTotal] = useState(0);
	const [filteredPatientTotal, setFilteresPatientTotal] = useState(0);
	const [patientPerPage, setPatientPerPage] = useState(10);
	const [patientPage, setPatientPage] = useState(savedPreferences?.pageNumber || 1);
	const [filteredPatientData, setFilteredPatientData] = useState([]);
	const [daysFilteredPatientData, setDaysFilteredPatientData] = useState([]);
	const [daysFilterPatientTotal, setDaysFilterPatientTotal] = useState(0);
	const [modal1Open, setModal1Open] = useState(false);
	const [shippingModal, setShippingModal] = useState(false);
	const [shippingDetailsModal, setShippingDetailsModal] = useState(false);
	const [patientDetails, setPatientDetails] = useState();
	const [categories, setCategories] = useState([]);
	const [products, setProducts] = useState([]);
	const [selectedShippingData, setSelectedShippingData] = useState();
	const [prescriberLoader, setPrescriberLoader] = useState(false);
	const [patientSearch, setPatientSearch] = useState(savedPreferences?.patientSearch || '');
	const [settingDetails, setSettingDetails] = useState();
	const [orderType, setOrderType] = useState(savedPreferences?.orderType || "single_order");
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [lastOrderday, setLastOrderday] = useState(savedPreferences?.lastOrderday || null);
	const [selectedAddressType, setSelectedAddressType] = useState();
	const [totalAmount, setTotalAmount] = useState(0);
	const [productDetails, setProductDetails] = useState();
	const [disableFilter, setDisableFilter] = useState(false);
	const [totalPatients, setTotalPatients] = useState(null);
	const [selectedPharmacy, setSelectedPharmacy] = useState("LifeFile");
	const [sortField, setSortField] = useState(savedPreferences?.sortField || null);
	const [sortOrder, setSortOrder] = useState(savedPreferences?.sortOrder || null);
	const [debouncedSearch, setDebouncedSearch] = useState(savedPreferences?.debouncedSearch || "");
	const [patientAppointments, setPatientAppointments] = useState([]);
	const [categoriesLoading, setCategoriesLoading] = useState(true);
	const [productsLoading, setProductsLoading] = useState(true);
	const [missingDetailsModal, setMissingDetailsModal] = useState(false);
	const [selectedPatientMissingDetails, setSelectedPatientMissingDetails] = useState(null);
	const [hasPatientAddress, setHasPatientAddress] = useState(true);
	const [modalLoader, setModalLoader] = useState(false);
	const [patientsWithMissingAddress, setPatientsWithMissingAddress] = useState([]);
	const [checkingAddresses, setCheckingAddresses] = useState(false);
	const [selectedStrengthKey, setSelectedStrengthKey] = useState(null);
	const [selectedStrengthLabel, setSelectedStrengthLabel] = useState(null);

	const [selectedDateRange, setSelectedDateRange] = useState(
		savedPreferences?.selectedDateRange
			? [dayjs(savedPreferences.selectedDateRange[0]), dayjs(savedPreferences.selectedDateRange[1])]
			: [dayjs().subtract(30, "day"), dayjs()]
	);

	useEffect(() => {
		const patientId = patientDetails?.patient?.id;
		if (modal1Open && patientId) {
			setModalLoader(true);
			getPatientAppointments(patientId).then((response) => {
				setPatientAppointments(response?.data);
				const address = response?.data?.address;
				setHasPatientAddress(!!(address && address.trim() !== ''));
				setModalLoader(false);
			}).catch((error) => {
				console.error({ error });
				setModalLoader(false);
				setHasPatientAddress(false);
			});
		}
	}, [modal1Open, patientDetails]);

	const validatePatientRequiredFields = (patient) => {
		const requiredFields = ['address', 'state', 'zip', 'city', 'email', 'date_of_birth'];
		const missingFields = [];

		requiredFields.forEach(field => {
			const value = patient[field];
			if (!value || value.trim() === '' || value === 'N/A') {
				missingFields.push(field);
			}
		});

		return missingFields;
	};

	useEffect(() => {
		getSettingDetails().then((response) => {
			setSettingDetails(response?.data)
		}).catch((error) => {
			console.error({ error })
		})

		// Load categories first
		getCategories().then((response) => {
			setCategoriesLoading(true);
			const categoriesList = response?.data?.categories || [];
			setCategories(categoriesList);
			setCategoriesLoading(false);

			// If we have saved category, load the products for that category
			if (savedPreferences?.selectedCategoryId) {
				getProductsById(savedPreferences.selectedCategoryId);
			}
			// Restore the patient list with the saved filters
			restoreFilteredPatients();
		}).catch((error) => {
			console.error({ error });
			setCategoriesLoading(false);
			setProductsLoading(false);
		});
	}, [])

	useEffect(() => {
		if (selectedProductId) {
			getProductDetail(selectedProductId.product_id);
		}
	}, [selectedProductId]);

	const getTotalPrice = (patiendIds) => {
		let formData = {
			"patient_ids": patiendIds,
			"product_id": selectedProductId?.value
		}

		getProductTotalPrice(formData).then((response) => {
			setTotalAmount(response?.data?.totalAmount)
		}).catch((error) => {
			console.error({ error })
		})
	}

	const getPatientData = (value) => {
		getPatientsWithAppointments(value)
			.then((response) => {
				setFilteredPatientData(response?.data?.data);
				setPatientTotal(response?.data?.total);
				setFilteresPatientTotal(response?.data?.total);
				setTotalPatients(response?.data?.total_patients);
			})
			.catch((err) => {
				console.error("err", err);
			});
	};

	const checkBulkOrderAddresses = async (patientIds) => {
		const missingAddressPatients = [];

		for (const patientId of patientIds) {
			try {
				const response = await getPatientAppointments(patientId);
				const address = response?.data?.address;
				const patient = response?.data;

				if (!address || address.trim() === '') {
					missingAddressPatients.push({
						id: patientId,
						name: `${patient?.first_name || ''} ${patient?.last_name || ''}`.trim()
					});
				}
			} catch (error) {
				console.error(`Error checking address for patient ${patientId}:`, error);
			}
		}

		return missingAddressPatients;
	};

	const getOrderData = (query) => {
		getOrder(query)
			.then((res) => {
				setorderData(res?.data?.data?.data);
				setOrderTotal(res?.data?.data?.total);
			})
			.catch((err) => {
				console.error("err", err);
			});
	}

	const getFilteredPatients = (value) => {
		getFilteredpatient(value).then((res) => {
			setDaysFilteredPatientData(res?.data?.data);
			setDaysFilterPatientTotal(res?.data?.total);
			setFilteredPatientData(res?.data?.data);
			setTotalPatients(res?.data?.total_patients || res?.data?.total);
			setDisableFilter(false);
			setProductsLoading(false);
			setCategoriesLoading(false);
		}).catch((error) => {
			setDisableFilter(false);
			setProductsLoading(false);
			setCategoriesLoading(false);
			console.error("Error fetching filtered patients:", error);
		});
	}

	const buildAndExecuteQuery = useCallback(() => {
		if (daysFilteredPatientData?.length === 0) {
			let query = `?per_page=${patientPerPage}&page=${patientPage}`;
			if (debouncedSearch !== '') {
				query += `&search=${debouncedSearch}`;
			}
			if (sortField && sortOrder) {
				query += `&sort_by=${sortField}&sort_direction=${sortOrder}`;
			}
			if (selectedDateRange && selectedDateRange?.length === 2) {
				const formattedStartDate = dayjs(selectedDateRange[0]).format("YYYY-MM-DD");
				const formattedEndDate = dayjs(selectedDateRange[1]).format("YYYY-MM-DD");
				query += `&start_date=${formattedStartDate}&end_date=${formattedEndDate}`;
			}
			// Add category filter if present
			if (selectedCategoryId) {
				query += `&category_id=${selectedCategoryId}`;
			}
			// Add product filter if present
			if (selectedProductId?.value) {
				query += `&service_category=${encodeURIComponent(selectedProductId.item_name)}`;
			}
			getPatientData(query);

			// Save the current query for restoration
			const currentPreferences = loadFilterPreferences() || {};
			saveFilterPreferences({
				...currentPreferences,
				lastQuery: query
			});
		} else if (daysFilteredPatientData?.length !== 0) {
			let query = `?days=${last_visit_days}&per_page=${patientPerPage}&page=${patientPage}`;
			if (debouncedSearch !== '') {
				query += `&search=${debouncedSearch}`
			}
			if (lastOrderday) {
				query += `&last_order_date=${lastOrderday}`
			}
			if (sortField && sortOrder) {
				query += `&sort_by=${sortField}&sort_direction=${sortOrder}`;
			}
			if (selectedDateRange && selectedDateRange?.length === 2) {
				const formattedStartDate = dayjs(selectedDateRange[0]).format("YYYY-MM-DD");
				const formattedEndDate = dayjs(selectedDateRange[1]).format("YYYY-MM-DD");
				query += `&start_date=${formattedStartDate}&end_date=${formattedEndDate}`;
			}
			// Add category filter if present
			if (selectedCategoryId) {
				query += `&category_id=${selectedCategoryId}`;
			}
			// Add product filter if present
			if (selectedProductId?.value) {
				query += `&service_category=${encodeURIComponent(selectedProductId.item_name)}`;
			}
			getFilteredPatients(query);

			// Save the current query for restoration
			const currentPreferences = loadFilterPreferences() || {};
			saveFilterPreferences({
				...currentPreferences,
				lastQuery: query
			});
		}
	}, [
		daysFilteredPatientData,
		patientPerPage,
		patientPage,
		debouncedSearch,
		sortField,
		sortOrder,
		selectedDateRange,
		selectedCategoryId,
		selectedProductId,
		last_visit_days,
		lastOrderday,
		getPatientData,
		getFilteredPatients
	]);

	// Function to restore filtered patients based on saved preferences
	const restoreFilteredPatients = useCallback(() => {
		const savedPrefs = loadFilterPreferences();
		if (savedPrefs?.lastQuery) {

			if (savedPrefs.lastQuery.includes('days=')) {
				getFilteredPatients(savedPrefs.lastQuery);
			} else {
				getPatientData(savedPrefs.lastQuery);
			}
		} else {
			// Otherwise build a new query from saved filters
			buildAndExecuteQuery();
		}
		setInitialDataLoaded(true);
	}, [getFilteredPatients, getPatientData, buildAndExecuteQuery, setInitialDataLoaded]);

	useEffect(() => {
		if (initialDataLoaded || !savedPreferences) {
			buildAndExecuteQuery();
		}
	}, [
		patientPerPage,
		patientPage,
		debouncedSearch,
		sortField,
		sortOrder,
		selectedDateRange,
		initialDataLoaded,
		selectedCategoryId,
		selectedProductId,
		last_visit_days,
		lastOrderday,
		daysFilteredPatientData?.length
	]);

	const handlePatientSearch = (event) => {
		setPatientPage(1)
		setPatientPerPage(10)
		setPatientSearch(event?.target?.value)

		// Save search term to preferences
		saveFilterPreferences({
			...loadFilterPreferences(),
			patientSearch: event?.target?.value
		});
	};

	useEffect(() => {
		if (patientSearch !== "") {
			const handler = setTimeout(() => {
				setDebouncedSearch(patientSearch);

				// Save debounced search to preferences
				saveFilterPreferences({
					...loadFilterPreferences(),
					debouncedSearch: patientSearch
				});
			}, 1000);
			return () => clearTimeout(handler);
		} else {
			setDebouncedSearch("");

			// Remove search from preferences if cleared
			const currentPreferences = loadFilterPreferences() || {};
			delete currentPreferences.debouncedSearch;
			delete currentPreferences.patientSearch;
			saveFilterPreferences(currentPreferences);
		}
	}, [patientSearch]);

	const onPageSizeChange = (current, size) => {
		setPatientPerPage(size);
		setPatientPage(1);

	};

	const generatePageSizeOptions = (total) => {
		const options = [];
		const maxPageSize = Math.min(total, 100);

		for (let i = 5; i <= maxPageSize; i += 5) {
			options.push(i);
		}
		if (total > 5 && !options.includes(10)) {
			options.push(10);
		}

		if (total > 10 && !options.includes(15)) {
			options.push(15);
		}
		return options.sort((a, b) => a - b);
	};

	const handleTableChange = (pagination, filters, sorter) => {
		if (sorter.order) {
			const field = sorter.field;
			const order = sorter.order === "ascend" ? "asc" : "desc";
			setSortField(field);
			setSortOrder(order);

			// Save sort preferences
			saveFilterPreferences({
				...loadFilterPreferences(),
				sortField: field,
				sortOrder: order,
				pageNumber: pagination.current,
			});
		} else {
			setSortField(null);
			setSortOrder(null);

			// Remove sort preferences
			const currentPreferences = loadFilterPreferences() || {};
			delete currentPreferences.sortField;
			delete currentPreferences.sortOrder;
			currentPreferences.pageNumber = pagination.current;
			saveFilterPreferences(currentPreferences);
		}
	};

	const handleOrder = (value) => {
		if (!selectedProductId) {
			Swal.fire({
				title: "Product",
				text: "Please select product.",
				icon: "info",
				confirmButtonText: "OK",
			});
			return;
		}

		if (value?.email === "") {
			Swal.fire({
				title: "Email Required",
				text: "We're unable to create your order because Strive requires a valid email address.",
				icon: "info",
				confirmButtonText: "OK",
			});
			return;
		}

		// Validate required fields
		const patientData = value?.patient || value;
		const missingFields = validatePatientRequiredFields(patientData);

		if (missingFields.length > 0) {
			const fieldLabels = {
				address: 'Address',
				state: 'State',
				zip: 'ZIP Code',
				city: 'City',
				email: 'Email',
				date_of_birth: 'Date of Birth',
			};

			Swal.fire({
				title: "Missing Required Information",
				html: `
        <div style="text-align: left;">
          <p style="margin-bottom: 15px; color: #8b7d6b;">
            The following required fields are missing for this patient:
          </p>
          <ul style="list-style: none; padding: 0; margin: 0;">
            ${missingFields.map(field => `
              <li style="padding: 8px; background: #fff7e6; margin-bottom: 8px; border-radius: 4px; border-left: 3px solid #faad14;">
                ${fieldLabels[field]}
              </li>
            `).join('')}
          </ul>
          <p style="margin-top: 20px; color: #8b7d6b;">
            Please update the patient's information before creating an order.
          </p>
        </div>
      `,
				icon: "warning",
				confirmButtonText: "Update Patient Info",
				confirmButtonColor: "#8b7d6b",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				width: '600px'
			}).then((result) => {
				if (result.isConfirmed) {
					handleEdit(patientData.id);
				}
			});
			return;
		}

		getTotalPrice([value?.id]);
		setModal1Open(true);
		setPatientDetails(value);
		form.setFieldsValue({
			drug_name: selectedProductId?.item_name,
		});
	};

	const bulkOrder = async () => {
		if (orderType === "bulk_order" && selectedRowKeys?.length <= 1) {
			Swal.fire({
				title: "Please select more than one patient for bulk order.",
				icon: "info",
				confirmButtonText: "OK",
			});
			return;
		}

		if (!selectedProductId) {
			Swal.fire({
				title: "Product",
				text: "Please select product.",
				icon: "info",
				confirmButtonText: "OK",
			});
			return;
		}

		// Show loading indicator while checking
		setCheckingAddresses(true);

		// Show a loading toast
		Swal.fire({
			title: 'Validating Patient Information',
			html: 'Please wait while we verify patient information and addresses...',
			allowOutsideClick: false,
			allowEscapeKey: false,
			didOpen: () => {
				Swal.showLoading();
			}
		});

		try {
			const missingAddressPatients = [];
			const missingRequiredFieldsPatients = [];

			// Check both addresses and required fields for all selected patients
			for (const patientId of selectedRowKeys) {
				try {
					const response = await getPatientAppointments(patientId);
					const patient = response?.data;
					const address = patient?.address;

					// Check if address is missing
					if (!address || address.trim() === '') {
						missingAddressPatients.push({
							id: patientId,
							name: `${patient?.first_name || ''} ${patient?.last_name || ''}`.trim()
						});
					}

					// Check required fields
					const missingFields = validatePatientRequiredFields(patient);
					if (missingFields.length > 0) {
						missingRequiredFieldsPatients.push({
							id: patientId,
							name: `${patient?.first_name || ''} ${patient?.last_name || ''}`.trim(),
							missingFields: missingFields
						});
					}
				} catch (error) {
					console.error(`Error checking patient ${patientId}:`, error);
				}
			}

			// Close the loading dialog
			Swal.close();
			setCheckingAddresses(false);

			// Combine all patients with issues (either missing address or missing required fields)
			const allPatientsWithIssues = new Map();

			missingAddressPatients.forEach(p => {
				allPatientsWithIssues.set(p.id, { ...p, issues: ['address'] });
			});

			missingRequiredFieldsPatients.forEach(p => {
				if (allPatientsWithIssues.has(p.id)) {
					const existing = allPatientsWithIssues.get(p.id);
					existing.issues = [...(existing.issues || []), ...p.missingFields];
					existing.missingFields = p.missingFields;
				} else {
					allPatientsWithIssues.set(p.id, { ...p, issues: p.missingFields });
				}
			});

			const patientsWithIssues = Array.from(allPatientsWithIssues.values());

			if (patientsWithIssues.length > 0) {
				setPatientsWithMissingAddress(patientsWithIssues);

				// Calculate valid patient count
				const validPatientCount = selectedRowKeys.length - patientsWithIssues.length;

				const fieldLabels = {
					address: 'Address',
					state: 'State',
					zip: 'ZIP Code',
					city: 'City',
					email: 'Email',
					date_of_birth: 'Date of Birth',

				};

				// If ALL patients have issues
				if (validPatientCount === 0) {
					Swal.fire({
						title: "Cannot Proceed",
						html: `
            <div style="text-align: left;">
              <p style="margin-bottom: 15px; color: #8b7d6b;">
                All <strong>${patientsWithIssues.length}</strong> selected patient(s) have missing required information:
              </p>
              <div style="max-height: 300px; overflow-y: auto;">
                ${patientsWithIssues.map(p => `
                  <div style="padding: 12px; background: #fff7e6; margin-bottom: 12px; border-radius: 4px; border-left: 3px solid #faad14;">
                    <div style="font-weight: 600; margin-bottom: 6px;">${p.name}</div>
                    <div style="font-size: 13px; color: #8b7d6b;">
                      Missing: ${p.issues.map(field => fieldLabels[field] || field).join(', ')}
                    </div>
                  </div>
                `).join('')}
              </div>
              <p style="margin-top: 20px; color: #8b7d6b;">
                Please update patient information before creating orders.
              </p>
            </div>
          `,
						icon: "error",
						confirmButtonText: "OK",
						confirmButtonColor: "#8b7d6b",
						width: '600px'
					});
					return;
				}

				// Show warning about patients with issues and allow continuing
				const result = await Swal.fire({
					title: "Missing Patient Information",
					html: `
          <div style="text-align: left; max-height: 400px; overflow-y: auto;">
            <p style="margin-bottom: 15px; color: #8b7d6b;">
              <strong>${patientsWithIssues.length}</strong> patient(s) have missing required information:
            </p>
            <div>
              ${patientsWithIssues.map(p => `
                <div style="padding: 12px; background: #fff7e6; margin-bottom: 12px; border-radius: 4px; border-left: 3px solid #faad14;">
                  <div style="font-weight: 600; margin-bottom: 6px;">${p.name}</div>
                  <div style="font-size: 13px; color: #8b7d6b;">
                    Missing: ${p.issues.map(field => fieldLabels[field] || field).join(', ')}
                  </div>
                </div>
              `).join('')}
            </div>
            <p style="margin-top: 20px; color: #8b7d6b;">
              Orders will only be created for the remaining <strong>${validPatientCount}</strong> patient(s) with complete information.
            </p>
          </div>
        `,
					icon: "warning",
					showCancelButton: true,
					confirmButtonText: "Continue with Valid Patients",
					cancelButtonText: "Cancel",
					confirmButtonColor: "#8b7d6b",
					cancelButtonColor: "#d33",
					width: '600px'
				});

				if (!result.isConfirmed) {
					return;
				}

				// Filter out patients with issues
				const validPatientIds = selectedRowKeys.filter(
					id => !patientsWithIssues.some(p => p.id === id)
				);

				// Update selected rows to only include valid patients
				setSelectedRowKeys(validPatientIds);
				getTotalPrice(validPatientIds);
			} else {
				getTotalPrice(selectedRowKeys);
			}

			setModal1Open(true);
			setOrderType('bulk_order');
			form.setFieldsValue({
				drug_name: selectedProductId?.item_name,
			});
		} catch (error) {
			console.error("Error validating patients:", error);
			Swal.close();
			setCheckingAddresses(false);
			Swal.fire({
				title: "Error",
				text: "An error occurred while validating patient information. Please try again.",
				icon: "error",
				confirmButtonText: "OK",
			});
		}
	};

	const handleEdit = (key) => {
		// Before navigating, ensure all current filter state is saved
		const currentPreferences = loadFilterPreferences() || {};

		// Make sure we save the current patient list state
		if (daysFilteredPatientData?.length > 0) {
			saveFilterPreferences({
				...currentPreferences,
				hasFilteredData: true,
				daysFilterPatientTotal
			});
		}

		navigate("/edit-patient", {
			state: { patientId: key },
		});
	}

	const pageSizeOptions = generatePageSizeOptions(patientTotal);
	// const pageSizeOptionsOrder = generatePageSizeOptions(orderTotal);

	const SaveSelectedKey = (value) => {
		// if (selectedRowKeys.length >= 10) {
		// 	Swal.fire({
		// 		title: "Limit Exceeded",
		// 		html: "The patient list for bulk orders cannot exceed the limit of <strong>10 patients</strong>.",
		// 		icon: "info",
		// 		confirmButtonText: "OK",
		// 	});

		// } else {
		setSelectedRowKeys((prevSelectedRowKeys) => {
			if (prevSelectedRowKeys.includes(value)) {
				return prevSelectedRowKeys.filter((key) => key !== value);
			} else {
				return [...prevSelectedRowKeys, value];
			}
		});
		// }
	};

	const checkBoxCheckFunction = (key) => {
		let findID = selectedRowKeys?.find((item) => item === key);

		if (findID !== undefined && findID !== null) {
			return true
		} else {
			return false;
		}
	}


	const viewDetails = (data) => {
		const patientData = data.patient || data;

		const missingFields = [];

		// Columns which we need to check for missingg data
		const fieldsToCheck = [
			{ key: 'email', label: 'Email' },
			{ key: 'phone', label: 'Phone' },
			{ key: 'address', label: 'Address' },
			{ key: 'city', label: 'City' },
			{ key: 'state', label: 'State' },
			{ key: 'zip', label: 'ZIP Code' },
			{ key: 'date_of_birth', label: 'Date of Birth' },
		];

		fieldsToCheck.forEach(field => {
			const value = patientData[field.key];
			if (value === null || value === undefined || value === "" || value === "N/A") {
				missingFields.push({
					field: field.label,
					key: field.key,
					currentValue: value === null || value === undefined ? "Not Provided" : value || "Not Provided"
				});
			}
		});

		setSelectedPatientMissingDetails({
			patientName: `${patientData.first_name || ''} ${patientData.last_name || ''}`.trim(),
			patientId: patientData.id,
			missingFields: missingFields
		});

		setMissingDetailsModal(true);
	}


	const tableColumns = [
		{
			title: "S.No",
			key: "serial_number",
			render: (text, record, index) => {
				const currentPage = patientPage;
				const pageSize = patientPerPage;
				return <span>{(currentPage - 1) * pageSize + index + 1}</span>;
			},
		},
		...(orderType === 'bulk_order' ? [
			{
				key: '',
				render: ((record) => (
					<>
						<Checkbox onChange={() => SaveSelectedKey(record?.patient?.id || record?.id)} checked={checkBoxCheckFunction(record?.patient?.id || record?.id)} />
					</>
				)),
			},
		] : []),
		{
			title: "Patients Name",
			dataIndex: "first_name",
			key: "first_name",
			sorter: true,
			render: (text, record) => (
				<span>{`${record?.first_name ? record?.first_name : record?.patient?.first_name} ${record?.last_name ? record?.last_name : record?.patient?.last_name}`}</span>
			),
		},
		{
			title: "Email",
			dataIndex: "email",
			key: "email",
			sorter: true,
			render: (text, record) => (
				<>
					{record?.email ? (<span>{record?.email}</span>) : record?.patient?.email ? (<span>{record?.patient?.email}</span>) : (<span className="text-center">N/A</span>)}
				</>
			),
		},
		{
			title: "Phone",
			dataIndex: "phone",
			key: "phone",
			sorter: true,
			render: (text, record) => (
				<>
					{record?.phone ? (<span>{record?.phone}</span>) : record?.patient?.phone ? (<span>{record?.patient?.phone}</span>) : (<span className="text-center">N/A</span>)}
				</>
			),
		},
		{
			title: "Address",
			dataIndex: "address",
			key: "address",
			sorter: true,
			render: (text, record) => (
				<span>{record?.address && record?.address !== "" ? record?.address : record?.patient?.address && record?.patient?.address !== "" ? (<span>{record?.patient?.phone}</span>) : "N/A"}</span>
			),
		},
		{
			title: "City",
			dataIndex: "city",
			key: "city",
			sorter: true,
			render: (text, record) => (
				<span>{record?.city && record?.city !== "" ? record?.city : record?.patient?.city && record?.patient?.city !== "" ? (<span>{record?.patient?.city}</span>) : "N/A"}</span>
			),
		},
		{
			title: "State",
			dataIndex: "state",
			key: "state",
			sorter: true,
			render: (text, record) => (
				<span>{record?.state && record?.state !== "" ? record?.state : record?.patient?.state && record?.patient?.state !== "" ? (<span>{record?.patient?.state}</span>) : "N/A"}</span>
			),
		},

		{
			title: "Missing Details",
			key: "missing_details",
			align: "center",
			render: (text, record) => (
				<Button
					type="link"
					icon={<EyeOutlined style={{ color: '#b4a099' }} />}
					onClick={() => viewDetails(record)}
					style={{ padding: 0 }}
				/>
			),
		},
		{
			title: "Appointment Details",
			key: "appointment-details",
			render: (text, record) =>
				daysFilteredPatientData?.length > 0 ? (
					<Button className="craete-order-button" onClick={() => handleEdit(record?.patient?.id)}>
						View Details
					</Button>
				) : (
					record?.appointments?.length > 0 ? (
						<Button className="craete-order-button" onClick={() => handleEdit(record?.id)}>
							View Details
						</Button>
					) : (<span style={{ fontSize: "11px" }} className="text-center">No Appointments Found</span>)
				)

		},
		...(orderType !== 'bulk_order' ? [
			{
				title: "Create Order",
				dataIndex: "create_order",
				key: "create_order",
				render: (text, record) => (
					<Button className="craete-order-button" onClick={() => handleOrder(record)}>
						Create Order
					</Button>
				),
			},
		] : []),
	];

	const onFinish = (value) => {
		setPrescriberLoader(true);
		let messageId = Math.floor(100000 + Math.random() * 900000);
		var currentdate = new Date();
		var datetime =
			"Last Sync: " +
			currentdate.getDate() +
			"/" +
			(currentdate.getMonth() + 1) +
			"/" +
			currentdate.getFullYear() +
			" @ " +
			currentdate.getHours() +
			":" +
			currentdate.getMinutes() +
			":" +
			currentdate.getSeconds();

		if (orderType === "single_order") {
			handleSingleOrder(value, messageId, datetime)
		} else if (orderType === "bulk_order") {
			handleBulkOrder(value, messageId, datetime)
		}
	};

	const handleSingleOrder = (value, messageId, datetime) => {
		const formData = {
			category: { category_id: selectedCategoryId },
			product: {
				product_id: selectedProductId?.product_id || selectedProductId?.value,
				product_name: selectedProductId?.product_name || selectedProductId?.item_name,
				product_strength: selectedProductId?.product_strength,
			},
			email: { email: patientDetails?.email ? patientDetails?.email : patientDetails?.patient?.email },
			message: { id: messageId, sentTime: datetime },
			order_type: "single",
			patient_id: patientDetails?.patient?.id || patientDetails?.id,
			user_id: userData?.id,
			type_of_address: value?.shipping_address === 'default' ? 'clinic' : 'patient',
			pharmacy_type: value?.pharmacy_type,
			order: {
				new_shipping_address: value?.new_shipping_address,
				practice: { id: 1094510 },
				customer_id: patientDetails?.customer_id,
				patient: {
					lastName: patientDetails?.last_name ? patientDetails?.last_name : patientDetails?.patient?.last_name,
					firstName: patientDetails?.first_name ? patientDetails?.first_name : patientDetails?.patient?.first_name,
					gender: patientDetails?.gender || 'u',
					dateOfBirth: patientDetails?.date_of_birth,
					address1: patientDetails?.address ? patientDetails?.address : patientDetails?.patient?.address,
					city: patientDetails?.city ? patientDetails?.city : patientDetails?.patient?.city,
					state: "AZ",
					zip: patientDetails?.zip ? patientDetails?.zip : patientDetails?.patient?.zip,
					phoneHome: patientDetails?.phone ? patientDetails?.phone : patientDetails?.patient?.phone,
				},
				rxs: [
					{
						rxType: "new",
						drugName: selectedProductId?.item_name,
						drugStrength: selectedStrengthLabel ? selectedStrengthLabel : null,
						drugForm: value?.drug_form,
						quantity: value?.quantity,
						quantityUnits: value?.quantity_units,
						directions: value?.directions,
						daysSupply: value?.daysSupply,
						clinicalDifferenceStatement: value?.clinicalDifferenceStatement,
						lfProductID: selectedStrengthKey || null,
					}
				],
			},
		};

		generateOrder(formData).then((response) => {
			// Check if there's an error in the response
			if (response.error) {
				Swal.fire({
					title: response.error.data.message,
					icon: "error",
					confirmButtonText: 'OK'
				});
				setPrescriberLoader(false);
				return;
			}

			// Success - Reset everything and close modal
			setSelectedRowKeys([]);
			setPatientDetails(null);
			setModal1Open(false);
			setSelectedAddressType(null);
			setSelectedPharmacy("LifeFile");
			setSelectedStrengthKey(null);
			setSelectedStrengthLabel(null);
			setTotalAmount(0);
			setPatientPage(1);
			form.resetFields();
			setPrescriberLoader(false);
			setOrderType("single_order");
			buildAndExecuteQuery();

			if (userData?.user_role === "nurse") {
				Swal.fire({
					title: "Order sent for approval",
					text: `${response?.data?.message}`,
					icon: "success",
					confirmButtonText: "OK",
				});
			} else {
				Swal.fire({
					title: "Order Generated",
					text: `${response?.data?.message}`,
					icon: "success",
					confirmButtonText: "OK",
				});
			}
		}).catch((error) => {
			setPrescriberLoader(false);
			setOrderType("single_order");

			Swal.fire({
				title: "Order Failed",
				text: "Your order has failed.",
				icon: "error",
				confirmButtonText: "OK",
			});
		});
	}

	const handleBulkOrder = (value, messageId, datetime) => {
		if (selectedProductId) {
			let formdata = {
				category: {
					category_id: selectedCategoryId,
				},
				product: {
					product_id: selectedProductId?.product_id || selectedProductId?.value,
					product_name: selectedProductId?.product_name || selectedProductId?.item_name,
					product_strength: selectedProductId?.product_strength,
				},
				order_type: "bulk",
				type_of_address: value?.shipping_address === 'default' ? 'clinic' : 'patient',
				pharmacy_type: value?.pharmacy_type,
				message: {
					id: messageId,
					sentTime: datetime
				},
				patient_id: selectedRowKeys,
				user_id: userData?.id,
				order: {
					new_shipping_address: value?.new_shipping_address,
					practice: {
						id: 1094510
					},
					rxs: [
						{
							rxType: "new",
							drugName: selectedProductId?.item_name,
							drugStrength: selectedStrengthLabel ? selectedStrengthLabel : null,
							drugForm: value?.drug_form,
							quantity: value?.quantity,
							quantityUnits: value?.quantity_units,
							directions: value?.directions,
							daysSupply: value?.daysSupply,
							clinicalDifferenceStatement: value?.clinicalDifferenceStatement,
							lfProductID: selectedStrengthKey || null,
						}
					]
				}
			};

			generateOrder(formdata).then((response) => {
				setPatientDetails(null);
				setSelectedRowKeys([]);
				setPatientsWithMissingAddress([]);
				setModal1Open(false);
				setSelectedAddressType(null);
				setSelectedPharmacy("LifeFile");
				setSelectedStrengthKey(null);
				setSelectedStrengthLabel(null);
				setTotalAmount(0);

				let successMessage = response?.data?.message;
				if (patientsWithMissingAddress.length > 0) {
					successMessage += `\n\nNote: ${patientsWithMissingAddress.length} patient(s) were skipped due to missing addresses.`;
				}

				if (userData?.user_role === "nurse") {
					Swal.fire({
						title: "Order sent for approval",
						text: successMessage,
						icon: "success",
						confirmButtonText: "OK",
					});
				} else {
					if (response.error) {
						Swal.fire({
							title: response.error.data.message,
							icon: "error",
							confirmButtonText: 'OK'
						});
					} else {
						Swal.fire({
							title: "Order Generated",
							text: successMessage,
							icon: "success",
							confirmButtonText: "OK",
						});
					}
				}

				form.resetFields();
				setPrescriberLoader(false);
				setOrderType("single_order");
				buildAndExecuteQuery();
			}).catch((error) => {
				setOrderType("single_order");
				form.resetFields();
				setPrescriberLoader(false);
				setPatientDetails();
				setModal1Open(false);
				setPatientsWithMissingAddress([]);
				setSelectedPharmacy("LifeFile");
				setSelectedStrengthKey(null);
				setSelectedStrengthLabel(null);
				Swal.fire({
					title: "Order Failed",
					text: "Your order have been failed.",
					icon: "error",
					confirmButtonText: "OK",
				});
			});
		} else {
			Swal.fire({
				title: "Product",
				text: "Please select product.",
				icon: "info",
				confirmButtonText: "OK",
			});
		}
	};
	const getProductDetail = (product_id) => {
		let formData = {
			product_id
		}

		getProductDetails(formData).then((response) => {
			setProductDetails(response?.data)
			form.setFieldsValue({
				drug_form: response?.data?.form,
				quantity_units: response?.data?.quantity_units,
				clinicalDifferenceStatement: response?.data?.statement
			});
		}).catch((error) => {
			console.error({ error })
		})
	}

	const getDrugStrengthOptions = () => {
		if (!selectedProductId || !selectedPharmacy) return [];

		const drugName = selectedProductId?.item_name?.toUpperCase();
		const isSiCompounding = selectedPharmacy === "SiCompounding";


		const buildOptionsFromStrength = (strength) => {
			if (!strength) return [];

			if (Array.isArray(strength)) {
				return strength.map((item) => (
					<Option key={item} value={item}>{item}</Option>
				));
			}

			if (typeof strength === 'object') {
				return Object.entries(strength).map(([key, label]) => (
					<Option key={key} value={key}>{label}</Option>
				));
			}

			return [];
		};

		const hasStrengthData = productDetails?.strength &&
			(Array.isArray(productDetails.strength)
				? productDetails.strength.length > 0
				: Object.keys(productDetails.strength).length > 0);

		if (!isSiCompounding) {
			if (hasStrengthData) {
				return buildOptionsFromStrength(productDetails.strength);
			}

			// Hardcoded fallbacks remain unchanged...
			if (drugName?.includes('SEMAGLUTIDE')) {
				return [
					<Option key="1" value="5/5/1 mg/ml 0.5ml Vial">5/5/1 mg/ml 0.5ml Vial</Option>,
					<Option key="2" value="5/5/1 MG/ML 1ml Vial">5/5/1 MG/ML 1ml Vial</Option>,
					<Option key="3" value="5/5/1 mg/ml 2ml Vial">5/5/1 mg/ml 2ml Vial</Option>,
				];
			} else if (drugName?.includes('TIRZEPATIDE')) {
				return [
					<Option key="4" value="10mg/5mg/500mcg/ml 1ml Vial">10mg/5mg/500mcg/ml 1ml Vial</Option>,
					<Option key="5" value="10mg/5mg/500mcg/ml 2ml Vial">10mg/5mg/500mcg/ml 2ml Vial</Option>,
					<Option key="6" value="10mg/5mg/500mcg/ml 3ml Vial">10mg/5mg/500mcg/ml 3ml Vial</Option>,
					<Option key="7" value="10mg/5mg/500mcg/ml 4ml Vial">10mg/5mg/500mcg/ml 4ml Vial</Option>,
				];
			} else {
				return [
					<Option key="default-1" value="5/5/1 mg/ml 1ml Vial">5/5/1 mg/ml 1ml Vial</Option>,
					<Option key="default-2" value="5/5/1 mg/ml 2ml Vial">5/5/1 mg/ml 2ml Vial</Option>,
					<Option key="default-3" value="10mg/5mg/500mcg/ml 2ml Vial">10mg/5mg/500mcg/ml 2ml Vial</Option>,
					<Option key="default-4" value="10mg/5mg/500mcg/ml 3ml Vial">10mg/5mg/500mcg/ml 3ml Vial</Option>,
					<Option key="default-5" value="10mg/5mg/500mcg/ml 4ml Vial">10mg/5mg/500mcg/ml 4ml Vial</Option>,
				];
			}
		}

		// ── SiCompounding path ──
		if (hasStrengthData) {
			const baseOptions = buildOptionsFromStrength(productDetails.strength);

			if (drugName?.includes('TIRZEPATIDE')) {
				return [...baseOptions, <Option key="tirzepatide-soh" value="20MG/15MG/10MG/ML (SOH)">20MG/15MG/10MG/ML (SOH)</Option>];
			}
			if (drugName?.includes('SEMAGLUTIDE')) {
				return [...baseOptions, <Option key="semaglutide-soh" value="5MG/15MG/5MG/ML INJECTION">5MG/15MG/5MG/ML Injection</Option>];
			}
			return baseOptions;
		}

		// SiCompounding hardcoded fallbacks remain unchanged...
		if (drugName?.includes('SEMAGLUTIDE')) {
			return [
				<Option key="sem-1" value="5/5/1 mg/ml 1ml Vial">5/5/1 mg/ml 1ml Vial</Option>,
				<Option key="sem-2" value="5/5/1 mg/ml 2ml Vial">5/5/1 mg/ml 2ml Vial</Option>,
				<Option key="sem-3" value="10mg/5mg/500mcg/ml 2ml Vial">10mg/5mg/500mcg/ml 2ml Vial</Option>,
				<Option key="sem-4" value="10mg/5mg/500mcg/ml 3ml Vial">10mg/5mg/500mcg/ml 3ml Vial</Option>,
				<Option key="sem-5" value="10mg/5mg/500mcg/ml 4ml Vial">10mg/5mg/500mcg/ml 4ml Vial</Option>,
				<Option key="semaglutide-soh" value="5MG/15MG/5MG/ML INJECTION">5MG/15MG/5MG/ML Injection</Option>
			];
		}
		if (drugName?.includes('TIRZEPATIDE')) {
			return [
				<Option key="tirz-1" value="5/5/1 mg/ml 1ml Vial">5/5/1 mg/ml 1ml Vial</Option>,
				<Option key="tirz-2" value="5/5/1 mg/ml 2ml Vial">5/5/1 mg/ml 2ml Vial</Option>,
				<Option key="tirz-3" value="10mg/5mg/500mcg/ml 2ml Vial">10mg/5mg/500mcg/ml 2ml Vial</Option>,
				<Option key="tirz-4" value="10mg/5mg/500mcg/ml 3ml Vial">10mg/5mg/500mcg/ml 3ml Vial</Option>,
				<Option key="tirz-5" value="10mg/5mg/500mcg/ml 4ml Vial">10mg/5mg/500mcg/ml 4ml Vial</Option>,
				<Option key="tirzepatide-soh" value="20MG/15MG/10MG/ML (SOH)">20MG/15MG/10MG/ML (SOH)</Option>
			];
		}
		return [
			<Option key="final-1" value="5/5/1 mg/ml 1ml Vial">5/5/1 mg/ml 1ml Vial</Option>,
			<Option key="final-2" value="5/5/1 mg/ml 2ml Vial">5/5/1 mg/ml 2ml Vial</Option>,
			<Option key="final-3" value="10mg/5mg/500mcg/ml 2ml Vial">10mg/5mg/500mcg/ml 2ml Vial</Option>,
			<Option key="final-4" value="10mg/5mg/500mcg/ml 3ml Vial">10mg/5mg/500mcg/ml 3ml Vial</Option>,
			<Option key="final-5" value="10mg/5mg/500mcg/ml 4ml Vial">10mg/5mg/500mcg/ml 4ml Vial</Option>,
		];
	};

	const onFinishFailed = (error) => {
		console.error({ error });
	};

	const getCategoriesList = () => {
		getCategories().then((response) => {
			setCategories(response?.data?.categories)
		}).catch((error) => {
			console.error({ error })
		})
	}

	const getProductsById = (selectedCategoryId) => {
		getProductsByCategoryId(selectedCategoryId).then((response) => {
			setProducts(response?.data?.data);
			setCategoriesLoading(false);
			setProductsLoading(false);
		}).catch((error) => {
			console.error({ error })
			setCategoriesLoading(false);
			setProductsLoading(false);
		})
	}

	const handleOrderType = (value) => {
		setOrderType(value);

		saveFilterPreferences({
			...loadFilterPreferences(),
			orderType: value
		});
	}

	useEffect(() => {
		if (selectedProductId) {
			form.setFieldsValue({
				drug_name: selectedProductId?.item_name,
			});
		}
	}, [selectedProductId]);

	const isTableLoading = isFilterPatientLoading || isLoadingPatient;

	const handleProductChange = async (e) => {
		setDisableFilter(true);
		setProductDetails(null);
		form.resetFields();

		const selectedProduct = products.find((product) => product.id === e);
		if (selectedProduct) {
			getProductDetail(selectedProduct.id);

			// Store all product details
			const productData = {
				value: selectedProduct.id,
				item_name: selectedProduct.item_name,
				product_id: selectedProduct.product_id || selectedProduct.id,
				product_name: selectedProduct.product_name || selectedProduct.item_name,
				product_strength: selectedProduct.product_strength || selectedProduct.strength,
			};

			setSelectedProductId(productData);

			// Save product preference
			saveFilterPreferences({
				...loadFilterPreferences(),
				selectedProductId: productData
			});

			let query = `?days=${last_visit_days ? last_visit_days : ""}&per_page=${10}&page=${1}`
			if (selectedProduct !== '') {
				query += `&service_category=${String(selectedProduct?.item_name)}`;
			}
			if (selectedCategoryId) {
				query += `&category_id=${selectedCategoryId}`;
			}
			getFilteredPatients(query);
		}
	}
	const validateShippingAddress = () => {
		const shippingAddressType = form.getFieldValue('shipping_address');
		const shippingAddress = form.getFieldValue('new_shipping_address');

		if (shippingAddressType === 'patient_address' && (!shippingAddress || shippingAddress.trim() === '')) {
			return false;
		}
		return true;
	};

	const resetFilters = () => {
		// Reset all filter states
		setSelectedCategoryId(null);
		setLastOrderday(null);
		setSelectedProductId(null);
		setOrderType("single_order");
		setLastVisit(null);
		setPatientSearch("");
		setDebouncedSearch("");
		setSelectedDateRange([dayjs().subtract(30, "day"), dayjs()]);
		setSortField(null);
		setSortOrder(null);

		setDaysFilteredPatientData([]);
		setFilteredPatientData([]);

		localStorage.removeItem(FILTER_STORAGE_KEY);

		let query = `?per_page=${patientPerPage}&page=${patientPage}`;

		getPatientsWithAppointments(query)
			.then((response) => {
				setFilteredPatientData(response?.data?.data);
				setPatientTotal(response?.data?.total);
				setFilteresPatientTotal(response?.data?.total);
				setTotalPatients(response?.data?.total_patients);
				setInitialDataLoaded(true); // Mark data as loaded
			})
			.catch((err) => {
				console.error("err", err);
			});
	}

	const handleOnChangeDate = (dates) => {
		setSelectedDateRange(dates);

		if (dates && dates.length === 2) {
			const formattedStartDate = dayjs(dates[0]).format("YYYY-MM-DD");
			const formattedEndDate = dayjs(dates[1]).format("YYYY-MM-DD");

			let query = `?per_page=${patientPerPage}&page=${patientPage}&start_date=${formattedStartDate}&end_date=${formattedEndDate}`;

			// Save filter preferences
			saveFilterPreferences({
				...loadFilterPreferences(),
				selectedDateRange: [dates[0].format(), dates[1].format()]
			});

		} else {
			const currentPreferences = loadFilterPreferences() || {};
			delete currentPreferences.selectedDateRange;
			saveFilterPreferences(currentPreferences);
		}
	};

	return (
		<>
			<div className="wrapper orderWrapper">
				<div className="container-fluid">
					<div className="row mb-1">
						<div className="col-md-12">
							<div className="titleBar d-flex justify-content-between">
								<h4>Order For Patients</h4>
								<div className="resetFiltersWrapper">
									<Button onClick={resetFilters} disabled={disableFilter}>Reset Filters</Button>
								</div>
							</div>

						</div>
					</div>

					<div className="row mb-4">
						<div className="col-md-12">
							<div className="topSection titleRow">
								<div className="leftSection">
								</div>
								<div className="rightSection rightWrapper justify-content-between w-100">
									<div className="filter-container ">
										<div>
											<p className="patient-filter-head">Filters</p>
											<div className="d-flex justify-content-between align-items-center">
												<div className="formItem me-3">
													<label htmlFor="lastVisitSelect" className="dynamicLabel">Search Patient</label>
													<Input
														placeholder="Search Patient.."
														value={patientSearch}
														onChange={handlePatientSearch}
														className="input_patient_search"
														disabled={disableFilter}
														allowClear
													/>
												</div>
												<div className="dateRangeWrapper">
													<label htmlFor="lastVisitSelect" className="dynamicLabel">Last Visited</label>
													<RangePicker
														format="MM/DD/YYYY"
														className="formSelect w-100"
														allowClear
														value={selectedDateRange}
														ranges={{
															Today: [dayjs(), dayjs()],
															"This Week": [dayjs().startOf("week"), dayjs().endOf("week")],
															"This Month": [dayjs().startOf("month"), dayjs().endOf("month")],
															"Last Month": [
																dayjs().subtract(1, "month").startOf("month"),
																dayjs().subtract(1, "month").endOf("month"),
															],
															"Last 6 Months": [
																dayjs().subtract(6, "month").startOf("month"),
																dayjs().endOf("month"),
															],
															"Last 30 Days": [dayjs().subtract(30, "day"), dayjs()],
														}}
														onChange={(dates) => handleOnChangeDate(dates)}
														disabled={disableFilter}
													/>
												</div>
											</div>
										</div>
									</div>
									<div className="filter-container" style={{ marginLeft: "60px" }}>
										<div>
											<p className="order-filter-head">Create Order</p>
											<div className="d-flex justify-content-between align-items-center">
												<div className="formItem">
													<label htmlFor="lastVisitSelect" className="dynamicLabel">Select Category</label>
													<Select
														placeholder="Select Category"
														style={{ width: "100%" }}
														value={categoriesLoading ? undefined : selectedCategoryId}
														className="formSelect"
														onClick={() => categories.length === 0 ? getCategoriesList() : <></>}
														onChange={(e) => {
															setSelectedCategoryId(e);
															setSelectedProductId(null);

															const selectedCategory = categories.find(cat => cat.id === e);
															saveFilterPreferences({
																...loadFilterPreferences(),
																selectedCategoryId: e,
																selectedCategoryName: selectedCategory?.name || '',
																selectedProductId: null
															});
															getProductsById(selectedCategory?.id)
														}}
														notFoundContent={
															categoriesLoading ? (
																<div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "8px" }}>
																	<Spin size="small" />
																</div>
															) : null
														}
														options={categories?.map((option) => ({
															value: option.id,
															label: option.name,
														}))}
														disabled={disableFilter}
													/>
												</div>
												<div className="formItem ms-3">
													<label htmlFor="lastVisitSelect" className="dynamicLabel">Select Product</label>
													<Select
														placeholder="Products"
														style={{ width: "100%" }}
														className="formSelect"
														disabled={!selectedCategoryId || disableFilter}
														value={productsLoading ? undefined : selectedProductId?.value}
														onChange={handleProductChange}
														notFoundContent={
															productsLoading ? (
																<div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "8px" }}>
																	<Spin size="small" />
																</div>
															) : isProductLoading ? (
																<div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "8px" }}>
																	<Spin size="small" />
																</div>
															) : (
																"No products found"
															)
														}
													>
														{products?.map((option) => (
															<Option key={option.id} value={option.id}>
																<span style={{ fontWeight: '500', fontSize: '14px' }}>
																	{option.product_name || option.item_name}
																</span>
															</Option>
														))}
													</Select>
												</div>
												<div className="formItem ms-3">
													<label htmlFor="lastVisitSelect" className="dynamicLabel">Select Order Type</label>
													<Select
														placeholder="Select Last Visit"
														className="formSelect w-100"
														onChange={(value) => {
															handleOrderType(value);
														}}
														value={orderType}
														disabled={disableFilter}
													>
														<Option value="single_order">Single</Option>
														<Option value="bulk_order">Bulk Order</Option>
													</Select>
												</div>
											</div>
										</div>

									</div>
								</div>
							</div>
						</div>
					</div>

					{showFilterSection && (
						<div className="card filterSection">
							<div className="card-header bg-white">
								<h4 className="card-title">Filters</h4>
							</div>
							<div className="card-body">
								<div className="row">
									<div className="col-md-4 mb-4">
										<Input
											placeholder="Date Last Visited"
											className="formControl"
										/>
									</div>
									<div className="col-md-4 mb-4">
										<Select
											placeholder="Exclude patients..."
											className="formSelect"
											style={{ width: "100%" }}
										>
											<Option value="exclude">
												Exclude all patients who have been ordered
											</Option>
										</Select>
									</div>
									<div className="col-md-4 mb-4">
										<Select
											placeholder="Select date last ordered"
											className="formSelect"
											style={{ width: "100%" }}
										>
											<Option value="date">Select date last ordered</Option>
										</Select>
									</div>
								</div>
							</div>
						</div>
					)}

					<div className="col-md-12 mb-5">
						<div className="card tableCard">
							<div className="cartd-body p-4">
								<div className="tableWrapper customPaginationTable">
									{orderType === "bulk_order" && (
										<p className="selected-patients-text">Selected Patients: {selectedRowKeys.length}</p>
									)}
									<Table
										className="registered-user-table"
										bordered
										columns={tableColumns}
										dataSource={isTableLoading ? [] : (filteredPatientData?.length > 0 ? filteredPatientData : daysFilteredPatientData)}
										pagination={
											(filteredPatientData?.length > 0 || daysFilteredPatientData?.length > 0)
												? {
													current: patientPage,
													pageSize: patientPerPage,
													total: daysFilteredPatientData?.length > 0 ? daysFilterPatientTotal : filteredPatientTotal,
													onChange: (page) => setPatientPage(page),
													onShowSizeChange: onPageSizeChange,
													showSizeChanger: true,
													showQuickJumper: true,
													pageSizeOptions: pageSizeOptions,
												}
												: false
										}
										loading={isTableLoading}
										onChange={handleTableChange}
										showSorterTooltip={false}
										scroll={{ x: 'auto' }}
										locale={{
											emptyText: isTableLoading ? ' ' : 'No Data'
										}}
										footer={() => {
											const displayTotal = daysFilteredPatientData?.length > 0
												? daysFilterPatientTotal
												: (filteredPatientData?.length > 0 ? filteredPatientTotal : totalPatients);

											return (
												<div className="d-flex justify-content-between align-items-center">
													<span><b>Total Patients:</b> {displayTotal || 0}</span>
												</div>
											);
										}}
									/>
								</div>
							</div>
						</div>
					</div>
					{orderType === "bulk_order" && selectedRowKeys?.length > 0 && (
						<div className="create-order-wrapper">
							<Button
								className="craete-order-button"
								onClick={bulkOrder}
								loading={checkingAddresses}
								disabled={checkingAddresses}
							>
								{checkingAddresses ? 'Validating Addresses...' : 'Create Bulk Order'}
							</Button>
						</div>
					)}
				</div>
			</div>

			<Modal
				title="Prescriber Information"
				centered
				open={modal1Open}
				onOk={() => {
					setModal1Open(false);
					form.resetFields();
					setSelectedAddressType(null);
					setSelectedPharmacy("LifeFile");
					setSelectedStrengthKey(null);
					setSelectedStrengthLabel(null);
				}}
				onCancel={() => {
					setModal1Open(false);
					form.resetFields();
					setSelectedAddressType(null);
					setSelectedPharmacy("LifeFile");
					setSelectedStrengthKey(null);
					setSelectedStrengthLabel(null);
				}}
				footer={false}
				width={1200}
				className="prescriberModal adding-margin"
			>
				{modalLoader ? (
					<>
						<div className="loaderWrapper">
							<Spin size="large" />
						</div>
					</>
				) : (
					<Form
						name="basic"
						layout="vertical"
						initialValues={{
							first_name: settingDetails?.prescriber_details?.firstName,
							last_name: settingDetails?.prescriber_details?.lastName,
							npi: settingDetails?.prescriber_details?.npi,
							pharmacy_type: "LifeFile"
						}}
						form={form}
						onFinish={onFinish}
						onFinishFailed={onFinishFailed}
						autoComplete="off"

					>
						{/* Pharmacy Selection */}
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item
									name="pharmacy_type"
									label="Select Pharmacy"
									rules={[{ required: true, message: "Please select a pharmacy." }]}
								>
									<Select
										placeholder="Select Pharmacy"
										onChange={(value) => {
											setSelectedPharmacy(value);
											form.setFieldsValue({ drugStrength: undefined });
										}}
									>
										<Option value="LifeFile">LifeFile</Option>
										<Option value="SiCompounding">Si Compounding</Option>
									</Select>
								</Form.Item>
							</Col>
						</Row>

						{/* First and Last Name Fields */}
						<Row gutter={24}>
							<Col span={8}>
								<Form.Item
									name="first_name"
									label="First Name"
									rules={[{ required: true, message: "Please enter first name." }]}
								>
									<Input disabled />
								</Form.Item>
							</Col>
							<Col span={8}>
								<Form.Item
									name="last_name"
									label="Last Name"
									rules={[{ required: true, message: "Please enter last name." }]}
								>
									<Input disabled />
								</Form.Item>
							</Col>
							<Col span={8}>
								<Form.Item
									name="npi"
									label="National Provider Identifier"
									rules={[{ required: true }]}
								>
									<Input disabled />
								</Form.Item>
							</Col>
							<Col span={8}>
								<Form.Item
									name="drug_name"
									label="Drug Name"
									rules={[{ required: true, message: "Please enter drug name." }]}
								>
									<Input disabled />
								</Form.Item>
							</Col>
							<Col span={8}>
								<Form.Item
									name="drugStrength"
									label="Drug Strength"
									rules={[{ required: true, message: "Please select drug strength." }]}
								>
									<Select
										placeholder="Select Drug Strength"
										disabled={prescriberLoader}
										onChange={(value, record) => {
											setSelectedStrengthKey(value);
											setSelectedStrengthLabel(record?.children);
										}}
									>
										{getDrugStrengthOptions()}
									</Select>
								</Form.Item>
							</Col>
							<Col span={8}>
								<Form.Item
									name="drug_form"
									label="Drug Form"
									rules={[{ required: true, message: "Please select drug form." }]}
								>
									<Select
										placeholder="Select Drug Form"
										disabled={prescriberLoader}
									>
										{productDetails ? (<Option value="Inj">{productDetails?.form}</Option>) : (
											<>
												<Option value="vials">Vials</Option>
												<Option value="doses">Doses</Option>
												<Option value="tablets">Tablets</Option>
												<Option value="capsules">Capsules</Option>
												<Option value="Inj">Injections</Option>
											</>
										)}

									</Select>
								</Form.Item>
							</Col>
							<Col span={8}>
								<Form.Item
									name="quantity"
									label="Order Quantity"
									rules={[{ required: true, message: "Please enter quantity." }]}
								>
									<Input
										type="text"
										placeholder="Please enter quantity"
										disabled={prescriberLoader}
										rules={[
											{
												validator: (_, value) =>
													value && value.length <= 3
														? Promise.resolve()
														: Promise.reject(
															new Error("Quantity must not exceed 3 digits.")
														),
											},
										]}
										maxLength={3}
										onKeyPress={(e) => {
											if (!/[0-9]/.test(e.key)) {
												e.preventDefault();
											}
										}}
										onClick={(e) => e.stopPropagation()}
										onPaste={(e) => {
											const paste = e.clipboardData.getData("text");
											if (!/^\d{0,5}$/.test(paste)) {
												e.preventDefault();
											}
										}}
									/>
								</Form.Item>
							</Col>
							<Col span={8}>
								<Form.Item
									name="daysSupply"
									label="Days of Supply"
									rules={[{ required: true, message: "Please days supply." }]}
								>
									<Input
										type="text"
										disabled={prescriberLoader}
										placeholder="Please enter days of supply"
										rules={[
											{
												validator: (_, value) =>
													value && value.length <= 3
														? Promise.resolve()
														: Promise.reject(
															new Error("Quantity must not exceed 3 digits.")
														),
											},
										]}
										maxLength={3}
										onKeyPress={(e) => {
											if (!/[0-9]/.test(e.key)) {
												e.preventDefault();
											}
										}}
										onClick={(e) => e.stopPropagation()}
										onPaste={(e) => {
											const paste = e.clipboardData.getData("text");
											if (!/^\d{0,5}$/.test(paste)) {
												e.preventDefault();
											}
										}}
									/>
								</Form.Item>
							</Col>
							<Col span={8}>
								<Form.Item
									name="quantity_units"
									label="Quantity Units"
									rules={[{ required: true, message: "Please select quantity units" }]}
								>
									<Select
										placeholder="Select Quantity Units"
										disabled={prescriberLoader}
									>
										<Option value="mL">ml</Option>
									</Select>
								</Form.Item>
							</Col>
							<Col span={8}>
								<Form.Item
									name="shipping_address"
									label="Select Shipping Address"
									rules={[{ required: true, message: "Please select shipping address!" }]}
								>
									<Select
										placeholder="Select Shipping Address"
										disabled={prescriberLoader}
										value={selectedAddressType}
										onChange={(e) => {
											setSelectedAddressType(e);
											if (e === 'patient_address') {
												if (patientAppointments) {
													const address = patientAppointments.address;
													if (address !== undefined) {
														form.setFieldsValue({
															new_shipping_address: address,
														});
													}
												}
											} else if (e === 'new_address') {
												form.setFieldsValue({
													new_shipping_address: '',
												});
											} else if (e === 'default') {
												form.setFieldsValue({
													new_shipping_address: '',
												});
											}
										}}
									>
										<Option value="default">Ship To Office</Option>
										<Option value="patient_address">Ship to patient</Option>
									</Select>

								</Form.Item>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								{hasPatientAddress && selectedAddressType === 'patient_address' && orderType !== "bulk_order" && (
									<Form.Item
										name="new_shipping_address"
										label="Shipping Address"
										rules={[{ required: true, message: "Shipping address is required." }]}
									>
										<TextArea
											disabled={prescriberLoader}
											rows={4}
											placeholder="Patient's shipping address"
											readOnly
											style={{
												backgroundColor: '#f5f5f5',
												border: '1px solid #d9d9d9'
											}}
										/>
									</Form.Item>
								)}

								{!hasPatientAddress && (
									<div style={{
										marginBottom: '24px',
										padding: '24px',
										backgroundColor: '#fff7e6',
										border: '2px dashed #faad14',
										borderRadius: '12px',
										textAlign: 'center'
									}}>
										<div style={{
											fontSize: '48px',
											marginBottom: '16px',
											color: '#faad14'
										}}>
											⚠️
										</div>
										<h3 style={{
											fontSize: '18px',
											fontWeight: '600',
											color: '#d48806',
											marginBottom: '12px'
										}}>
											Patient Address Not Available
										</h3>
										<p style={{
											color: '#8b7d6b',
											fontSize: '14px',
											marginBottom: '20px',
											lineHeight: '1.6'
										}}>
											This patient doesn't have a shipping address on file. Please update their profile with a valid shipping address before creating an order for home delivery.
										</p>
										<Button
											type="primary"
											icon={<EditOutlined />}
											onClick={() => {
												const patientId = patientDetails?.patient?.id || patientDetails?.id;
												handleEdit(patientId);
												setModal1Open(false);
											}}
											style={{
												backgroundColor: '#8b7d6b',
												borderColor: '#8b7d6b',
												height: '40px',
												padding: '0 32px',
												fontSize: '15px',
												fontWeight: '500',
												borderRadius: '6px'
											}}
										>
											Update Patient Address
										</Button>
									</div>
								)}


							</Col>

							<Col span={24}>
								<div className="total-amount-container">
									{isTotalPriceLoading ? (<Spin />) : (
										<>
											<h3 className="total-amount-heading">Total Amount</h3>
											<p className="total-amount-price">${totalAmount}</p>
										</>
									)}
								</div>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<Form.Item
									name="clinicalDifferenceStatement"
									label="Clinical Difference Statement"
									rules={[{ required: true, message: "Please enter clinical difference statement." }]}
								>
									<TextArea
										disabled={prescriberLoader}
										rows={4}
										placeholder="Please enter clinical difference statement."
									/>
								</Form.Item>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<Form.Item
									name="directions"
									label="Drug Directions"
									rules={[{ required: true, message: "Please enter drug direction." }]}
								>
									<TextArea
										disabled={prescriberLoader}
										rows={4}
										placeholder="Please enter directions to take drug."
									/>
								</Form.Item>
							</Col>
						</Row>

						<div className="actionWrapper">
							{/* Submit Button */}
							<Form.Item>
								<Button disabled={prescriberLoader || !hasPatientAddress} icon={<MdRefresh />}
									loading={prescriberLoader} type="primary" htmlType="submit" block className="customSubmitButton">
									Submit
								</Button>
							</Form.Item>
						</div>
					</Form>
				)}
			</Modal>

			<Modal
				title="Add Shipping Details"
				centered
				open={shippingModal}
				onOk={() => setShippingModal(false)}
				onCancel={() => setShippingModal(false)}
				className="prescriberModal"
				footer={false}
				width={600}
			>
				<Shipping getOrderData={getOrderData} selectedOrderData={selectedOrderData} setShippingModal={setShippingModal} />
			</Modal>

			<Modal
				title="Shipping Details"
				centered
				open={shippingDetailsModal}
				onOk={() => setShippingDetailsModal(false)}
				onCancel={() => setShippingDetailsModal(false)}
				className="prescriberModal"
				footer={false}
			>
				<ShippingDetails selectedShippingData={selectedShippingData} />
			</Modal>

			<Modal
				title={
					<div style={{
						display: 'flex',
						alignItems: 'center',
						gap: '12px',
						padding: '8px 0'
					}}>
						<div style={{
							width: '40px',
							height: '40px',
							borderRadius: '50%',
							backgroundColor: '#f0f0f0',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							color: '#8b7d6b'
						}}>
							<EyeOutlined style={{ fontSize: '20px' }} />
						</div>
						<div>
							<div style={{ fontSize: '18px', fontWeight: '600', color: '#333' }}>
								Missing Details
							</div>
							<div style={{ fontSize: '13px', fontWeight: '400', color: '#8b7d6b' }}>
								{selectedPatientMissingDetails?.patientName || 'Patient'}
							</div>
						</div>
					</div>
				}
				centered
				open={missingDetailsModal}
				onCancel={() => {
					setMissingDetailsModal(false);
					setSelectedPatientMissingDetails(null);
				}}
				width={800}
				footer={
					<div style={{
						display: 'flex',
						gap: '12px',
						justifyContent: 'flex-end',
						padding: '12px 0'
					}}>
						<Button
							key="close"
							size="large"
							onClick={() => {
								setMissingDetailsModal(false);
								setSelectedPatientMissingDetails(null);
							}}
							style={{
								borderRadius: '6px',
								padding: '8px 24px',
								height: 'auto',
								border: '1px solid #d9d9d9'
							}}
						>
							Close
						</Button>
						<Button
							key="edit"
							type="primary"
							size="large"
							icon={<EditOutlined />}
							onClick={() => {
								handleEdit(selectedPatientMissingDetails?.patientId);
								setMissingDetailsModal(false);
								setSelectedPatientMissingDetails(null);
							}}
							style={{
								borderRadius: '6px',
								padding: '8px 24px',
								height: 'auto',
								backgroundColor: '#8b7d6b',
								borderColor: '#8b7d6b'
							}}
						>
							Edit Patient
						</Button>
					</div>
				}
				className="missing-details-modal"
			>
				{selectedPatientMissingDetails?.missingFields?.length > 0 ? (
					<div style={{
						maxHeight: '500px',
						overflowY: 'auto',
						padding: '8px'
					}}>
						<div style={{
							marginBottom: '24px',
							padding: '16px',
							backgroundColor: '#fff9f0',
							borderLeft: '4px solid #faad14',
							borderRadius: '8px'
						}}>
							<p style={{
								margin: 0,
								color: '#8b7d6b',
								fontSize: '14px',
								lineHeight: '1.6'
							}}>
								<strong style={{ color: '#333' }}>
									{selectedPatientMissingDetails.missingFields.length} field{selectedPatientMissingDetails.missingFields.length > 1 ? 's' : ''}
								</strong> need{selectedPatientMissingDetails.missingFields.length === 1 ? 's' : ''} attention for this patient record.
							</p>
						</div>
						<div style={{
							display: 'grid',
							gap: '12px'
						}}>
							{selectedPatientMissingDetails.missingFields.map((item, index) => (
								<div
									key={index}
									style={{
										padding: '20px',
										backgroundColor: '#fafafa',
										borderRadius: '10px',
										border: '1px solid #e8e8e8',
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
										transition: 'all 0.3s ease',
										cursor: 'default'
									}}
									onMouseEnter={(e) => {
										e.currentTarget.style.backgroundColor = '#f5f5f5';
										e.currentTarget.style.borderColor = '#d9d9d9';
										e.currentTarget.style.transform = 'translateX(4px)';
									}}
									onMouseLeave={(e) => {
										e.currentTarget.style.backgroundColor = '#fafafa';
										e.currentTarget.style.borderColor = '#e8e8e8';
										e.currentTarget.style.transform = 'translateX(0)';
									}}
								>
									<div style={{ flex: 1 }}>
										<div style={{
											fontSize: '15px',
											fontWeight: '600',
											color: '#333',
											marginBottom: '6px',
											display: 'flex',
											alignItems: 'center',
											gap: '8px'
										}}>
											<span style={{
												width: '6px',
												height: '6px',
												borderRadius: '50%',
												backgroundColor: '#ff4d4f',
												display: 'inline-block'
											}}></span>
											{item.field}
										</div>
									</div>
									<div style={{
										backgroundColor: '#fff1f0',
										color: '#ff4d4f',
										padding: '6px 16px',
										borderRadius: '20px',
										fontSize: '12px',
										fontWeight: '600',
										letterSpacing: '0.5px',
										boxShadow: '0 2px 4px rgba(255,77,79,0.1)'
									}}>
										REQUIRED
									</div>
								</div>
							))}
						</div>
					</div>
				) : (
					<div style={{
						textAlign: 'center',
						padding: '60px 20px',
						background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
						borderRadius: '12px',
						margin: '20px 0'
					}}>
						<div style={{
							fontSize: '64px',
							marginBottom: '20px',
							animation: 'scaleIn 0.5s ease-out'
						}}>✓</div>
						<h3 style={{
							color: '#52c41a',
							marginBottom: '12px',
							fontSize: '20px',
							fontWeight: '600'
						}}>
							All Information Complete
						</h3>
						<p style={{
							color: '#8b7d6b',
							fontSize: '14px',
							maxWidth: '400px',
							margin: '0 auto',
							lineHeight: '1.6'
						}}>
							This patient has all required information filled in. The record is complete and ready for processing.
						</p>
					</div>
				)}
			</Modal>

			<style jsx>{`
			.loaderWrapper {
			display:flex;
			justify-content:center;
			align-items:center;
			height:300px;
		}
			.missing-details-modal .ant-modal-header {
				border-bottom: 2px solid #f0f0f0;
				padding: 20px 24px;
			}
			.missing-details-modal .ant-modal-body {
				padding: 24px;
			}
			.missing-details-modal .ant-modal-footer {
				border-top: 2px solid #f0f0f0;
				padding: 16px 24px;
			}
			@keyframes scaleIn {
				from {
					transform: scale(0);
					opacity: 0;
				}
				to {
					transform: scale(1);
					opacity: 1;
				}
			}
			@keyframes fadeIn {
				from {
					opacity: 0;
					transform: translateY(-10px);
				}
				to {
					opacity: 1;
					transform: translateY(0);
				}
			}
			@media (max-width: 768px) {
				.missing-details-modal {
					max-width: 95vw !important;
				}
				.missing-details-modal .ant-modal-body {
					padding: 16px;
				}
			}
		`}
			</style>

			<style jsx>{`
	.missing-details-modal .ant-modal-header {
		border-bottom: 2px solid #f0f0f0;
		padding: 20px 24px;
	}
	.missing-details-modal .ant-modal-body {
		padding: 24px;
	}
	.missing-details-modal .ant-modal-footer {
		border-top: 2px solid #f0f0f0;
		padding: 16px 24px;
	}
	@keyframes scaleIn {
		from {
			transform: scale(0);
			opacity: 0;
		}
		to {
			transform: scale(1);
			opacity: 1;
		}
	}
	@media (max-width: 768px) {
		.missing-details-modal {
			max-width: 95vw !important;
		}
		.missing-details-modal .ant-modal-body {
			padding: 16px;
		}
	}
`}
			</style>
		</>
	);
};

export default OrderingForMedication;
